import { render } from "./djylResourceNew.vue?vue&type=template&id=c1f059ac&scoped=true"
import script from "./djylResourceNew.vue?vue&type=script&lang=js"
export * from "./djylResourceNew.vue?vue&type=script&lang=js"

import "./djylResourceNew.vue?vue&type=style&index=0&id=c1f059ac&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1f059ac"]])

export default __exports__